// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************


// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =================================================================================================================
// Nav Bar
// =================================================================================================================

// Set up constants
const nav = document.getElementById("main-nav");
const adminBar = document.getElementById('wpadminbar'); // WordPress Admin Bar


// Change Nav state after scrolling down
// -----------------------------------------------------------------------------------------------------------------
if (nav) {
    window.addEventListener('scroll', function () {
        const scrollPoint = 20; // pixel value after which state change is triggered
        this.scrollY > scrollPoint ? nav.classList.add('scrolled') : nav.classList.remove('scrolled');
    })
}



// Set the nav size for use in CSS
// ---------------------------------------------------------------------------------------------------------------------
function setCssNavbarHeight() {
    if (this.scrollY < 30 ) {
        document.documentElement.style.setProperty('--nav-height', nav.offsetHeight + "px");
    }
}

window.addEventListener('load', setCssNavbarHeight);
document.addEventListener('DOMContentLoaded', setCssNavbarHeight, false);
window.addEventListener('resize', setCssNavbarHeight, false);

// Get the size of the navbar at all times
function setCssNavbarHeightScrolled() {
    document.documentElement.style.setProperty('--nav-height-scrolled', nav.offsetHeight + "px");
}
window.addEventListener('load', setCssNavbarHeightScrolled);
document.addEventListener('DOMContentLoaded', setCssNavbarHeightScrolled, false);
window.addEventListener('resize', setCssNavbarHeightScrolled, false);
window.addEventListener('scroll', function () {
    setTimeout(function (){
        document.documentElement.style.setProperty('--nav-height-scrolled', nav.offsetHeight + "px");
    }, 300);
});


// Check for WordPress admin bar and pushes Nav down if it exists
// ---------------------------------------------------------------------------------------------------------------------
if (adminBar) {
    function setAdminBarHeight() {
        document.documentElement.style.setProperty('--admin-bar-height', adminBar.offsetHeight + "px");
    }

    window.addEventListener('load', setAdminBarHeight);
    document.addEventListener('DOMContentLoaded', setAdminBarHeight, false);
    window.addEventListener('resize', setAdminBarHeight, false);

    // Change Nav state after scrolling past start scrollPoint
    window.addEventListener('scroll', function () {
        if (breakpointManager.matchesBreakpointsDown('xs')) {
            let adminBarHeight = adminBar.offsetHeight;

            if (this.scrollY > adminBarHeight) {
                document.documentElement.style.setProperty('--admin-bar-height', "0px");
            } else if (this.scrollY < adminBarHeight) {
                let adminBarOffset = adminBarHeight  - this.scrollY;
                document.documentElement.style.setProperty('--admin-bar-height', adminBarOffset + "px");
            }
        }
    });

}

// Navbar Toggle - for use with Offcanvas
const navbarOffcanvas = document.getElementById('navbarOffcanvas')
const navToggler = document.getElementById('nav-menu-btn');
navbarOffcanvas.addEventListener('show.bs.offcanvas', () => {
    navToggler.classList.remove('collapsed');
})
navbarOffcanvas.addEventListener('hide.bs.offcanvas', () => {
    navToggler.classList.add('collapsed');
})



// =====================================================================================================================
// Scroll Bar
// =====================================================================================================================

// Set the Scroll Bar size for use in CSS
function setCSSScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', (scrollbarWidth) + "px");
}

// Set scrollbar width on events
window.addEventListener('load', setCSSScrollbarWidth);
window.addEventListener('load', setCSSScrollbarWidth);
document.addEventListener('DOMContentLoaded', setCSSScrollbarWidth, false);
window.addEventListener('resize', setCSSScrollbarWidth, false);



// =====================================================================================================================
// Splide
// =====================================================================================================================
import Splide from '@splidejs/splide';
import {forEach} from "@splidejs/splide/src/js/utils";


// Logos Slider
// ------------------------------------------------------------------------------------------------------------------
const logosSlider = document.querySelectorAll('.logos-slider .splide');
if (logosSlider.length) {
    logosSlider.forEach(function(logoSlider) {
        const slider = new Splide(logoSlider, {
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 2000,
            type: 'loop',
            perMove: 1,
            gap: '6rem',
            focus: 'center',
            fixedWidth: '100px',
            fixedHeight: '50px',
            breakpoints: {
                1460: {
                    gap: '5.5rem',
                },
                1200: {
                    gap: '5rem',
                },
                992: {
                    gap: '4.5rem',
                },
                768: {
                    gap: '3.5rem',
                },
                576: {
                    gap: '3rem',
                    fixedWidth: '85px',
                    fixedHeight: '45px',
                },
                390: {
                    fixedWidth: '75px',
                    fixedHeight: '40px',
                    gap: '2.5rem'
                }
            }
        })
        slider.mount();
    });
}



// Slider Group Block
// ------------------------------------------------------------------------------------------------------------------
const sliderGroups = document.querySelectorAll('.slider-group .splide');
if (sliderGroups.length) {
    sliderGroups.forEach(function(sliderGroup) {
        const sliderOptions = {
            type: sliderGroup.dataset.slidertype ?? 'slide',
            arrows: sliderGroup.dataset.arrows === 'true',
            pagination: sliderGroup.dataset.pagination === 'true',
            drag: sliderGroup.dataset.drag === 'true',
            autoplay: sliderGroup.dataset.autoplay === 'true',
            perPage: sliderGroup.dataset.perpage ?? 1,
            interval: sliderGroup.dataset.interval ?? 5000,
            gap: sliderGroup.dataset.gap,
            padding: sliderGroup.dataset.padding,
            breakpoints: {
                768: {
                    arrows: false,
                },
            }
        }
        const slider = new Splide(sliderGroup, sliderOptions)
        slider.mount();
    });
}



// Product Tabs Block
// ------------------------------------------------------------------------------------------------------------------
const productTabsBlocks = document.querySelectorAll('.product-tabs .splide');
if (productTabsBlocks.length) {
    productTabsBlocks.forEach(function(slider) {
        const carousel = new Splide(slider, {
            arrows: true,
            pagination: false,
            perPage: 1,
            type: 'fade',
            rewind: true,
            autoplay: true,
            interval: 5000,
            drag: false,
            breakpoints: {
                768: {
                    drag: true,
                },
            }
        });

        // Progress Bars
        let progressBars = slider.querySelectorAll('.splide__progress__bar');
        carousel.on('autoplay:playing', rate => {
            progressBars.forEach( bar => {
                bar.style.width = `${rate * 100}%`
            });
        });

        // Mount Carousel
        carousel.mount();

        // Carousel tab buttons
        const tabs = slider.querySelectorAll('.tab-btn');
        const tabNames = slider.querySelectorAll('.tab-name');
        tabs.forEach(function(tab, index){
            if (index === 0) {
                tab.classList.add('active');
                tab.setAttribute('disabled', 'true');
            }
            tab.addEventListener('click', function (){
                carousel.go(index);
            })
        })


        // Carousel move event
        carousel.on('move', (index)=> {
            tabs.forEach(function(tab, tabIndex){
                if (tabIndex !== index) {
                    tab.classList.remove('active');
                    tab.removeAttribute('disabled');
                } else {
                    tab.classList.add('active');
                    tab.setAttribute('disabled', 'true');
                }
            })
            tabNames.forEach(function(tab, tabIndex){
                if (tabIndex !== index) {
                    tab.classList.remove('active');
                } else {
                    tab.classList.add('active');
                }
            })
        })
    });
}



// Testimonials Slider
// ---------------------------------------------------------------------------------------------------------------------
const testimonialsSliders = document.querySelectorAll('.testimonials .splide');
if (testimonialsSliders) {
    testimonialsSliders.forEach((testimonialsSlider) => {
        const slider = new Splide(testimonialsSlider, {
            type: 'loop',
            autoplay: true,
            interval: 7000,
            arrows: true,
            pagination: false,
            gap: '1.625rem',
            fixedWidth: '415px',
            focus: 'center',
            perMove: 1,
            breakpoints: {
                768: {
                    fixedWidth: null,
                    perPage: 1,
                    padding: '12px',
                },
            }
        });
        slider.mount()
    });
}



// Scroll List Slider
// ---------------------------------------------------------------------------------------------------------------------
const scrollListSliders = document.querySelectorAll('.scroll-list .splide');
if (scrollListSliders) {
    scrollListSliders.forEach((list) => {
        const slider = new Splide(list, {
            mediaQuery: 'min',
            arrows: true,
            pagination: false,
            perPage: 1,
            perMove: 1,
            gap: '2rem',
            breakpoints: {
                768: {
                    destroy: true,
                }
            }
        });
        let counter = list.querySelector('.current-slide');
        slider.mount()
        slider.on('move', (index) => {
            let counterNum = index + 1;
            counter.innerHTML = counterNum.toString().padStart(2, '0');
        })
    });
}



// =====================================================================================================================
// GSAP
// =====================================================================================================================
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let matchMedia = gsap.matchMedia();


// Scroll List
// ---------------------------------------------------------------------------------------------------------------------
let scrollList = document.querySelectorAll('.scroll-list');
if (scrollList) {
    scrollList.forEach((list) => {
        matchMedia.add("(min-width: 768px)", () => {
            // Scroll Content
            let scrollItems = list.querySelectorAll('.scroll-item');
            scrollItems.forEach((item, index) => {
                if (index === 0) {
                    item.classList.add('active');
                    ScrollTrigger.create({
                        trigger: item,
                        start: "top center",
                        end: "bottom center",
                        toggleClass: "active",
                        onLeaveBack: () => {
                            item.classList.add('active');
                        }
                    });
                } else if (index === scrollItems.length - 1) {
                    ScrollTrigger.create({
                        trigger: item,
                        start: "top center",
                        end: "bottom center",
                        toggleClass: "active",
                        onLeave: () => {
                            item.classList.add('active');
                        }
                    });
                } else {
                    ScrollTrigger.create({
                        trigger: item,
                        start: "top center",
                        end: "bottom center",
                        toggleClass: "active",
                    });
                }

            })

            // Pin images
            let scrollImages = list.querySelectorAll('.scroll-item figure')
            scrollImages.forEach((image) => {
                ScrollTrigger.create({
                    trigger: image,
                    start: "center center",
                    pin: true,
                    endTrigger: '.scroll-list',
                    end: () => '+=' + (list.offsetHeight - image.offsetHeight),
                })
            })
        })
    });
}



// =====================================================================================================================
// Filter
// =====================================================================================================================
const postFilter = document.getElementById('post-filters');
if (postFilter) {
    postFilter.addEventListener('change', () => {
        if (window.location.href.indexOf("/page/") > -1) {
            postFilter.action = window.location.origin + '/resources';
            postFilter.submit();
        } else {
            postFilter.submit();
        }
    });
}

const postResetBtn = document.getElementById("post-reset-btn");
if (postResetBtn){
    postResetBtn.addEventListener("click", () => {
        window.location.assign(window.location.origin + '/resources')
    });
}